import {
  useParams,
  useSearchParams,
  Link as RouterLink,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { responsiveAlertActionSx } from "../utils/sx";

const reasonCopy: Record<string, string> = {
  expired:
    "Your verification link has expired. Please request a new one from your dashboard.",
  used: "This verification link has already been used.",
  invalid: "This verification link is invalid.",
};

export default function VerifyEmailPage() {
  const { status } = useParams<{ status: string }>();
  const [searchParams] = useSearchParams();

  const isSuccess = status === "ok";

  if (isSuccess) {
    return (
      <Box sx={{ maxWidth: 560, mx: "auto", mt: 8, px: 3 }}>
        <Helmet>
          <meta name="robots" content="noindex,nofollow" />
        </Helmet>
        <Alert
          severity="success"
          sx={responsiveAlertActionSx}
          action={
            <Button
              component={RouterLink}
              to="/dashboard/overview"
              color="inherit"
              size="small"
            >
              Go to dashboard
            </Button>
          }
        >
          <AlertTitle>Email verified</AlertTitle>
          Your email address is now verified. You can start rendering PDFs.
        </Alert>
      </Box>
    );
  }

  const reason = searchParams.get("reason") ?? "";
  const message =
    reasonCopy[reason] ?? "We couldn't verify your email. Please try again.";

  return (
    <Box sx={{ maxWidth: 560, mx: "auto", mt: 8, px: 3 }}>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <Alert
        severity="error"
        sx={responsiveAlertActionSx}
        action={
          <Button
            component={RouterLink}
            to="/dashboard/overview"
            color="inherit"
            size="small"
          >
            Go to dashboard
          </Button>
        }
      >
        <AlertTitle>Verification failed</AlertTitle>
        {message} If you&apos;re already logged in, use &quot;Resend email&quot;
        on your dashboard banner.
      </Alert>
    </Box>
  );
}
